// Player colours (names are the wire values the server accepts).
export const PLAYER_COLORS: Record<string, { label: string; hex: string }> = {
  peacock: { label: "Peacock", hex: "#1fb5ad" },
  marigold: { label: "Marigold", hex: "#ffb23f" },
  rani: { label: "Rani", hex: "#ff5e8e" },
  mehendi: { label: "Mehendi", hex: "#8bc34a" },
  mango: { label: "Mango", hex: "#ff8a3d" },
  lotus: { label: "Lotus", hex: "#f7a8c8" },
  sky: { label: "Sky", hex: "#5ab0ff" },
  chilli: { label: "Chilli", hex: "#ef4444" },
  jamun: { label: "Jamun", hex: "#a678f0" },
  tulsi: { label: "Tulsi", hex: "#2fbf71" },
};

export const COLOR_NAMES = Object.keys(PLAYER_COLORS);

export function colorHex(name: string): string {
  return PLAYER_COLORS[name]?.hex ?? "#cfc9ea";
}
